module.exports = __webpack_public_path__ + "Unreal-f0f38224.webp";